import PersonaPlaceholder from './components/PersonaPlaceholder';
import { createLazyComponent, LazyModule } from 'owa-bundling';

const personaControlLazyModule = new LazyModule(
    () =>
        import(
            /* webpackChunkName: "MiniPersona", webpackPrefetch: true */ './personaControlLazyIndex'
        )
);

export const PersonaControl = createLazyComponent(
    personaControlLazyModule,
    m => m.PersonaControl,
    PersonaPlaceholder
);

const personaControlV2LazyModule = new LazyModule(
    () =>
        import(
            /* webpackChunkName: "MiniPersonaV2", webpackPrefetch: true */ './personaControlV2LazyIndex'
        )
);

export const PersonaControlV2 = createLazyComponent(
    personaControlV2LazyModule,
    m => m.PersonaControlV2,
    PersonaPlaceholder
);

export { PersonaSize } from 'fabric-persona/lib/components/Persona.Props';
